import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  jsonLd?: object | object[]; // <-- accepte aussi un tableau
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = "Neoqualis — ESN experte en Testing & Business Analysis",
  description = "Testing fonctionnel & automatisé, performance, BA/PO. Réduisez les risques et accélérez vos mises en production avec l'expertise Neoqualis, QualisAI et Qualis-Academy.",
  canonical = "https://neoqualis.com/",
  ogImage = "https://neoqualis.com/og-image.jpg",
  jsonLd
}) => {
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* JSON-LD */}
      {blocks.map((blk, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(blk)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEOHead;
